export default "__VITE_ASSET__KTUCRsE3__"